Vue.component('streamer_community_leaderboard', {
    template: templates.streamersCommunityLeaderBoard,
    data() {
      return {
        model: {
     
        }
      }
    },
    mounted() {
      const c = this;
     
    },
    methods: {
     
  
    
    
    }
  });